module.exports = __webpack_public_path__ + "static/media/llp-icon-infinity.b2a28bad.svg";